import { useCallback } from 'react'

import { igaoPages } from '../../igao/utils'
import { FriendlyDateTime } from '../Date/friendly-date-time'
import { Toast } from '../NarusMaterial'

interface IgaoToastProps {
  path: string
  user: {name: string}
  time: string
  id: string
  place: string
  close: (id: string) => void
}

export function IgaoToast ({ path, user, time, id, close }: IgaoToastProps): JSX.Element {
  const handleClose = useCallback((): void => {
    close(id)
  }, [ close, id ])

  const page = igaoPages.find(i => i.id === path)?.name ?? path

  return (
    <Toast onDelete={handleClose}>
      <Content
        page={page}
        user={user}
        time={time}
      />
    </Toast>
  )
}

interface ContentProps {
  user: {name: string}
  time: string
  page: string
}

function Content ({ user, time, page }: ContentProps): JSX.Element {
  return (
    <>
      <h2>Questionnaire Updated</h2>
      <p>{page} questionnaire updated by {user.name}</p>
      <p className='time'>
        <FriendlyDateTime datetime={time} />
      </p>
    </>
  )
}
